import { action } from "satcheljs";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";

const resetSchedulesViewStateStore = action(
    "resetSchedulesViewStateStore", (
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({ viewState : viewState })
);

export default resetSchedulesViewStateStore;
